import { CardCategoryEnum } from '../card'
import { TenantMemberDisplayData } from '../identity'
import { WithPermissions } from '../shared'

export type TenantCelebrationPref = {
  tenantId: string
  birthdayPublic: boolean
  birthdayCards: boolean
  anniversaryPublic: boolean
  anniversaryCards: boolean
  welcomePublic: boolean
  welcomeCards: boolean
  onboardingDays: number[] | []
  onboardingCards: boolean
  createdAt: string | null
  updatedAt: string | null
  __entity_type__: 'tenantPreference'
}

export type TenantCelebrationPrefParams = Pick<
  TenantCelebrationPref,
  | 'birthdayPublic'
  | 'birthdayCards'
  | 'anniversaryPublic'
  | 'anniversaryCards'
  | 'welcomePublic'
  | 'welcomeCards'
  | 'onboardingDays'
  | 'onboardingCards'
>

export type MemberCelebrationPref = {
  memberId: string
  tenantId: string
  birthdayPublic: boolean
  anniversaryPublic: boolean
  onboardingPublic: boolean
  createdAt: string | null
  updatedAt: string | null
  __entity_type__: 'memberPreference'
}

export type MemberCelebrationPrefParams = {
  birthdayPublic: boolean
  anniversaryPublic: boolean
  onboardingPublic: boolean
}

export type CelebrationType = CalendarEventTypeEnum | CardCategoryEnum

export enum CelebrationTypeEnum {
  BIRTHDAY = 'birthday',
  ANNIVERSARY = 'anniversary',
  WELCOME = 'welcome',
  ONBOARDING = 'onboarding',
  OTHER = 'other',
}

/** Calendar events for Celebrations */
export enum CalendarEventTypeEnum {
  BIRTHDAY = 'birthday',
  ANNIVERSARY = 'anniversary',
  WELCOME = 'welcome',
  ONBOARDING = 'onboarding',
}

export enum SimplifiedEventTypeEnum {
  ANNIVERSARY = CalendarEventTypeEnum.ANNIVERSARY,
  BIRTHDAY = CalendarEventTypeEnum.BIRTHDAY,
  WELCOME = CalendarEventTypeEnum.WELCOME,
  ONBOARDING = CalendarEventTypeEnum.ONBOARDING,
  MILESTONES = 'milestones',
}

export type CalendarEvent = WithPermissions<{
  type: CalendarEventTypeEnum
  celebratedOn: string
  memberId: string
  interval: number
  memberDisplayData: TenantMemberDisplayData | null
  // embeds
  publicCardId?: string | null
  memberName?: string | null
  __entity_type__: 'calendarEvent'
}>

export type ListCalendarEventsEmbeds = 'member' | 'publicCardId' | 'memberName'

export type ListCalendarEventsParams = {
  typeIn?: string[]
  dateRange?: string[]
  dateRangePreset?: string
  memberIdIn?: string[]
  teamIdIn?: string[]
  embeds?: ListCalendarEventsEmbeds[]
}
